// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c18a2f6e","455":"8f91ead2","977":"7bf9c08a"}[chunkId] + ".chunk.js";
};